import { supplierResponseViewPropsTypes } from "../SupplierResponseViewPropsTypes";
import SupplierView from "../../SupplierView";
function SupplierResponseView({
  surveyAnswersInfo,
  setSurveyAnswersInfo,
  surveyAnswers,
  setSurveyAnswers,
  questionObjVariable,
  surveyAnswerDocId,
}: supplierResponseViewPropsTypes) {
  return (
    <SupplierView
      surveyAnswersInfo={surveyAnswersInfo}
      setSurveyAnswersInfo={setSurveyAnswersInfo}
      surveyAnswers={surveyAnswers}
      setSurveyAnswers={setSurveyAnswers}
      questionObjVariable={questionObjVariable}
      surveyAnswerDocId={surveyAnswerDocId}
      isPreview={false}
    />
  );
}
export default SupplierResponseView;
